/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralLookup } from '../../models/general-lookup';
import { GeneralLookupDto } from '../../models/general-lookup-dto';

export interface AddGeneralLookup$Params {
      body: GeneralLookupDto
}

export function addGeneralLookup(http: HttpClient, rootUrl: string, params: AddGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
  const rb = new RequestBuilder(rootUrl, addGeneralLookup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralLookup>;
    })
  );
}

addGeneralLookup.PATH = '/api/lookuptable';
